<template>
  <div v-if="length > 0" :class="[size, { readonly: readonly }]" class="Rate flex">
    <svg width="0" height="0" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <symbol id="icon-star-full" viewBox="0 0 32 32">
          <path d="M32 12.408l-11.056-1.607-4.944-10.018-4.944 10.018-11.056 1.607 8 7.798-1.889 11.011 9.889-5.199 9.889 5.199-1.889-11.011 8-7.798z" />
        </symbol>
      </defs>
    </svg>
    <input v-model="rate" :name="name" :required="required" type="hidden">
    <template v-for="n in length">
      <button
        :key="n"
        :class="{ 'Rate__star': true, 'hover': n <= over, 'filled': (n <= rate || isFilled(n))}"
        :disabled="disabled"
        type="button"
        class="block"
        @mouseover="onOver(n)"
        @mouseout="onOut(n)"
        @click="setRate(n)"
        @keyup.exact="onOver(n)"
        @keyup.enter="setRate(n)"
      >
        <svg class="ricon">
          <use xlink:href="#icon-star-full" />
        </svg>
      </button>
    </template>
    <div v-if="showcount" class="Rate__view" :class="{disabled: disabled}">
      <span class="count">{{ over }}</span>
      <span v-if="ratedesc.length > 0" class="desc">{{ ratedesc[over - 1] }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AppRate',
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    name: { type: String, default: 'rate' },
    size: { type: String, default: 'default' },
    length: {
      type: Number,
      default: 5
    },
    showcount: { type: Boolean },
    required: { type: Boolean },
    ratedesc: { type: Array, default () { return [] } },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false }
  },
  data () {
    return {
      over: 0,
      rate: 0
    }
  },
  watch: {
    value (val) {
      this.rate = this.convertValue(this.value)
      this.over = this.convertValue(this.value)
    }
  },
  created () {
    if (this.value >= this.length) {
      this.value = this.length
    } else if (this.value < 0) {
      this.value = 0
    }
    this.rate = this.convertValue(this.value)
    this.over = this.convertValue(this.value)
  },
  methods: {
    convertValue (value) {
      if (value >= this.length) {
        value = this.length
      } else if (value < 0) {
        value = 0
      }
      return value
    },
    onOver (index) {
      if (!this.readonly) {
        this.over = index
      }
    },
    onOut () {
      if (!this.readonly) {
        this.over = this.rate
      }
    },
    setRate (index) {
      if (this.readonly) {
        return false
      }
      this.$emit('before-rate', this.rate)
      this.rate = index
      this.$emit('input', this.rate)
      this.$emit('after-rate', this.rate)
    },
    isFilled (index) {
      return index <= this.over
    },
    isEmpty (index) {
      if (!this.over) {
        return index > this.over || !this.value
      }
    }
  }
}
</script>
<style>

.ricon {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  stroke-width: 0;
  stroke: currentColor;
  fill: currentColor;
  vertical-align: middle;
  position: relative;

}

.Rate__star{
  color: rgb(239 99 134 / var(--tw-bg-opacity));
  transition: all .25s;
  outline: none;
  opacity: .2;
  margin: 0;
  padding: 0;
  display: inline-block;
  text-decoration: none;
  cursor: pointer;
  background: transparent none;
  border: 0;
}
.Rate__star:not(:last-child) {
    margin-right: .5rem;
  }
  /*
  &:focus:not(:hover){
    .ricon{
      box-shadow: $focus;
    }
  }
  */


.Rate__star .ricon{
  top: 0;
  vertical-align: middle;
}
/*
.Rate__star.hover{
  &:not([disabled]){
    opacity: 1;
    &:hover{
      transform: scale(1.5);
    }
  }
  &:active{
    transform: scale(1);
    cursor: pointer;
  }
}*/
.Rate.readonly .Rate__star:hover{
      transform: scale(1);
      cursor: default;
}
.Rate__star.filled{
  opacity: 1;
}

.Rate__star:hover,
.Rate__star:focus{text-decoration: none;}
.Rate__view{
  display: inline-block;
  vertical-align: middle;
}
.Rate__view .count,
.Rate__view .desc{
  display: inline-block;
  vertical-align: middle;
}

.Rate.has-error .Rate__star{color: #f37a77;}
.Rate.has-error .Rate__star.hover{color: #efc20f;}
.Rate.has-error .Rate__star.filled{color: #efc20f;}

.Rate__star[disabled] .ricon {
    opacity: 0.3;
    cursor: default;
}
</style>
